import { render, staticRenderFns } from "./Tchaer.vue?vue&type=template&id=517cba20&scoped=true&"
import script from "./Tchaer.vue?vue&type=script&lang=js&"
export * from "./Tchaer.vue?vue&type=script&lang=js&"
import style0 from "./Tchaer.vue?vue&type=style&index=0&id=517cba20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517cba20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/regalstreak/development/web/souvenirsofconflict/souvenirsofconflict/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
